import { Checkbox as MuiCheckbox, CheckboxProps as MuiCheckboxProps } from '@mui/material';
import { forwardRef } from 'react';

export const Checkbox = forwardRef<HTMLInputElement, MuiCheckboxProps>((props, ref) => (
  <MuiCheckbox {...props} inputRef={ref} />
));
